import {
    Admin,
    Author,
    PublishingAuthor,
} from '@deltek/specification-client/core/Configurations/Authorization'
import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import { UserType } from '@deltek/specification-client/core/Widgets/ProductListing/productsUtils'
import ProductListingsPage from 'bpm/pages/ProductCardManagementPage/ProductListingsPage'
import ProductDetailsPage from 'bpm/pages/ProductsPage/ProductDetailsPage'

const allowedRoles = [
    `${Admin}|${UserType.Deltek}`,
    `${Author}|${UserType.Deltek}`,
    `${PublishingAuthor}|${UserType.Deltek}`,
]
export const ProductsCardManagementPageRoutes: RouteDictionary = {
    '/': {
        redirect:
            '/all?groupby=sectionNumber%2520false%252CproductType%2520false&sortby=sectionNumber%252CproductType%252Ctype%252ClastUpdated%2520desc&defaultFilter=true&showBackButton=false',
    },
    '/all': {
        name: 'Product Listings',
        component: ProductListingsPage,
        allowedRoles,
    },
    '/product/listing/:listingId': {
        name: 'Product Details',
        component: ProductDetailsPage,
        allowedRoles,
    },
}
